import RoundingSection from './price/rounding';
import PriceSection from './price/price';
export default class Price {
    constructor() {
        this.Price = new PriceSection();
        this.Rounding = new RoundingSection();
    }
    init() {
        this.setElement();
        this.checkRoundingState();
        this.Price.getTypeElement().addEventListener('change', () => {
            this.Price.getPriceElement().value = '';
            this.checkRoundingState();
        });
    }
    setElement() { }
    getValue() { }
    setValue(value) {
        this.Price.setType('flat');
        this.Price.getPriceElement().value = value.price;
    }
    getElement() {
        return this.element;
    }
    show() {
        this.getElement().style.display = 'block';
    }
    hide() {
        this.getElement().style.display = 'none';
    }
    checkRoundingState() {
        if (this.Price.getType() === 'flat' || this.Price.getType() === 'clear') {
            this.Rounding.hide();
        }
        else {
            this.Rounding.show();
        }
    }
}
